import {LotoCardboard} from "../../domain/entities/LotoCardboard";
import {LotoCardboardRepository} from "../ports/LotoCardboardRepository";

export class ListLotoCardboards {
    constructor(private readonly repo: LotoCardboardRepository) {}

    async execute(): Promise<LotoCardboard[]> {
        return this.repo.list();
    }
}
